import * as React from "react";
import { GraphCommand } from "../interfaces/config";
import { cutSurface } from "../utils";
export class GraphCutHandler extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { data, graph, xValues, yValues, zValues } = this.props;
        if (graph.command === GraphCommand.cuts) {
            let cutData = { data: {}, objects: [] };
            const newXValues = [];
            const newYValues = [];
            const newElements = graph.surfaces.map((surf, index) => {
                const cutPoins = cutSurface(surf, data, xValues[index], yValues[index], zValues[index]);
                newXValues.push("X" + surf.title);
                newYValues.push("Y" + surf.title);
                cutData.data[newXValues[index]] = cutPoins.map((el) => el.distance);
                cutData.data[newYValues[index]] = cutPoins.map((el) => el.zCoord);
                const singleElement = {
                    colX: newXValues[index],
                    colY: newYValues[index],
                    colZ: "",
                    file: null,
                    fillSymbol: surf.fillStyle,
                    lineStyle: surf.lineStyle,
                    lineWidth: surf.lineWidth,
                    symbol: surf.symbol,
                    symbolColor: surf.color,
                    symbolSize: surf.symbolSize,
                    title: surf.title,
                };
                return singleElement;
            });
            const newGraphConfig = Object.assign(Object.assign({}, graph), { elements: newElements });
            return this.props.render(cutData, newXValues, newYValues, newGraphConfig);
        }
        return this.props.render(data, xValues, yValues, graph);
    }
}
//# sourceMappingURL=index.js.map